import { SITE_IDS } from "./sites";
import pageAdEn1x from "/img/ads/playmaker-ad-en@1x.png";
import pageAdEn2x from "/img/ads/playmaker-ad-en@2x.png";
import pageAdSv1x from "/img/ads/playmaker-ad-sv@1x.png";
import pageAdSv2x from "/img/ads/playmaker-ad-sv@2x.png";

type SiteAdData = Record<
  string,
  { srcSetSmall: string; srcSetLarge: string; altText: string }
>;

export const isSiteWithAd = (
  site: string,
  sitesAdData: SiteAdData,
): site is SITE_IDS => {
  return site in sitesAdData;
};

export const PageAdData = {
  main_sv: {
    srcSetSmall: pageAdSv1x,
    srcSetLarge: pageAdSv2x,
    altText: "Fantasy Playmaker AI",
  },
  main_en: {
    srcSetSmall: pageAdEn1x,
    srcSetLarge: pageAdEn2x,
    altText: "Fantasy Playmaker AI",
  },
};
